export const imageThumbnail = (url: string): string => {
  const urlParts = url.split('.');

  if (urlParts.length < 2) {
    return urlParts.join('-300x300.');
  }

  const extension = urlParts.pop();
  const baseUrl = urlParts.join('.');

  return `${baseUrl}-300x300.${extension}`;
};
